// extracted by mini-css-extract-plugin
export default {"container":"Content_container__B7wQS","notFoundContainer":"Content_notFoundContainer__Kayqw"};